import { render } from "./SaverTrackerPage.vue?vue&type=template&id=2fe4335c"
import script from "./SaverTrackerPage.vue?vue&type=script&lang=js"
export * from "./SaverTrackerPage.vue?vue&type=script&lang=js"

import "./SaverTrackerPage.vue?vue&type=style&index=0&id=2fe4335c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__